const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]", "::1"]);

/**
 * Страница открыта на машине разработчика.
 *
 * Нужно там, где поведение должно отличаться от боевого: логи включаются, отправка ошибок
 * выключается. Проверяем именно хост, а не режим сборки: production-сборку регулярно
 * открывают локально — на preview-сервере или при разборе бага, — и такие запуски
 * не должны попадать в боевой проект Sentry.
 */
export const isLocalHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const { hostname } = window.location;
  return LOCAL_HOSTS.has(hostname) || hostname.endsWith(".local");
};
